import React from "react";
import { List } from "antd";

import Config from '../config/Config';

const sourcePath = Config.getSourcePath();

class WidgetList extends React.Component {

    constructor( props )
    {
        super(props);
    }

    pageTurning = (page, pageSize) => {

        if( this.props.pageTurning )
        {
            this.props.pageTurning(page, pageSize);
        }
    }

    extra = ( item ) => {

        const { options } = this.props;

        if( this.props.extra )
        {
            return this.props.extra(item);
        }
        else if( options.delete )
        {
            return <img onClick={ (key) => { this.notify(item, "delete")} } width={20} alt="logo" src={ require("./../img/" + sourcePath + "/ai-chat/delete.png")} />
        }
        else
        {
            return <></>
        }
    }

    notify = ( item, type) => {

        if( this.props.notify )
        {
            this.props.notify(item, type);
        }
    }

    ListTitle = ( item ) => {

        const {options} = this.props;

        if( options.transform && this.props.notify )
        {
            return this.props.notify(item, "title");
        }
        else
        {
            return <span>{item.title}</span>;
        }
    }
    
    avatar = ( item ) => {
       
        const {options} = this.props;

        if( options.avatar && this.props.notify )
        {
            return this.props.notify(item, "avatar");
        }
    }

    render()
    {
        let { data, total, options, page, loading } = this.props;

        return (
            <div className="sf-list">
                <List
                    itemLayout="vertical"
                    size="large"
                    loading={loading || false}
                    pagination={{
                        total: total,
                        current: page || 1,
                        onChange: (page, pageSize) => { this.pageTurning(page, pageSize)  },
                        pageSize: options.records || 10,
                        showSizeChanger: true,
                    }}
                    dataSource={data}
                    renderItem={(item) => (
                        <List.Item
                            key={item.key}
                            extra={ <Extra item={item} options={options} notify={this.extra}></Extra>}
                        >
                            <List.Item.Meta
                                // avatar= { () => { return this.avatar(item) } }
                                title = { <ListTitle item={item} options={options} notify={this.ListTitle} ></ListTitle>}
                                description={item.description ? item.description : <></>}
                            />
                                { item.content ? item.content : <></>}
                        </List.Item>
                    )}
                />
            </div>
        )
    }
}

export default WidgetList

export const ListTitle = ({ item, options, notify, ...props }) => {

    if( options.transform )
    {
        return notify(item);
    }
    else
    {
        return <span>{item.title}</span>;
    }

}

export const Extra = ({ item, options, notify, ...props }) => {

    return notify(item);

}